export default [
    "MBBS",
    "MD",
    "MS",
    "DNB",
    "MCH",
    "DM",
    "BDS",
    "MDS",
    "BHMS",
    "DHMS",
    "BEMS",
    "DEMS",
    "LCEH",
    "BUMS",
    "BAMS",
    "BSMS",
    "Other",
];